var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _vm.cadastrante.tipo === "PF"
            ? _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("app-display", {
                    attrs: {
                      label: "Nome completo:",
                      content: _vm.cadastrante.pessoaFisica.nome
                    }
                  }),
                  _vm._v(" "),
                  _c("app-display", {
                    attrs: {
                      label: "CPF:",
                      content: _vm.cadastrante.pessoaFisica.cpf
                    }
                  })
                ],
                1
              )
            : _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("app-display", {
                    attrs: {
                      label: "Razão social:",
                      content: _vm.cadastrante.pessoaJuridica.razaoSocial
                    }
                  }),
                  _vm._v(" "),
                  _c("app-display", {
                    attrs: {
                      label: "Nome fantasia:",
                      content: _vm.cadastrante.pessoaJuridica.nomeFantasia
                    }
                  }),
                  _vm._v(" "),
                  _c("app-display", {
                    attrs: {
                      label: "CNPJ:",
                      content: _vm.cadastrante.pessoaJuridica.cnpj
                    }
                  })
                ],
                1
              ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c("app-display", {
                attrs: {
                  label: "E-mail(s):",
                  content: _vm.cadastrante.emails.length
                    ? _vm.cadastrante.emails
                        .map(function(e) {
                          return e.dado
                        })
                        .join(", ")
                    : null
                }
              }),
              _vm._v(" "),
              _c("app-display", {
                attrs: {
                  label: "Telefone(s):",
                  content: _vm.cadastrante.telefones.length
                    ? _vm.cadastrante.telefones
                        .map(function(t) {
                          return t.numero
                        })
                        .join(", ")
                    : null
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mt-2" },
        [
          _vm._m(1),
          _vm._v(" "),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("app-display", {
                    attrs: {
                      label: "CEP:",
                      content: _vm.cadastrante.enderecoCorrespondencia.cep
                    }
                  }),
                  _vm._v(" "),
                  _c("app-display", {
                    attrs: {
                      label: "Logradouro:",
                      content:
                        _vm.cadastrante.enderecoCorrespondencia.logradouro
                    }
                  }),
                  _vm._v(" "),
                  _c("app-display", {
                    attrs: {
                      label: "Número:",
                      content: _vm.cadastrante.enderecoCorrespondencia.numero
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("app-display", {
                    attrs: {
                      label: "Complemento:",
                      content:
                        _vm.cadastrante.enderecoCorrespondencia.complemento
                    }
                  }),
                  _vm._v(" "),
                  _c("app-display", {
                    attrs: {
                      label: "Bairro:",
                      content: _vm.cadastrante.enderecoCorrespondencia.bairro
                    }
                  }),
                  _vm._v(" "),
                  _c("app-display", {
                    attrs: {
                      label: "Município/UF:",
                      content: _vm.cadastrante.enderecoCorrespondencia.municipio
                        ? _vm.formataMunicipioUF(
                            _vm.cadastrante.enderecoCorrespondencia.municipio
                          )
                        : ""
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("span", { staticClass: "title-cadastrante" }, [
        _vm._v("Dados do cadastrante")
      ]),
      _vm._v(" "),
      _c("hr")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("span", { staticClass: "title-cadastrante" }, [
        _vm._v("Endereço de correspondência")
      ]),
      _vm._v(" "),
      _c("hr")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-59f2c2ad", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59f2c2ad","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components(new)/UI/Modals/VisualizacaoCadastro/Cadastro/Cadastrante/Cadastrante.vue
// module id = null
// module chunks = 